module.exports = new __parcel__URL__("mining_back_to_missions_button.db037c6d.png").toString();